import {PACK_ROUTES as packRoutes} from "~/api/routes";

export const state = () => ({
  packs: [],
  details: {},
  close:false,
  isRequesting:false
});
export const getters = {};
export const mutations = {
  PACKS_LOAD(state) {
    //state.isLoading = true;
    state.hasError = false;
    state.packs = [];
    //state.page = page;
  },
  CLOSE_MODAL(state,close){
    state.close = close;
  },
  IS_REQUESTING(state,isRequesting){
    state.isRequesting = isRequesting
  },
  PACKS_SUCCES(state, packs) {
    try{
      packs.forEach((details) => {
        // details['date_debut']=details['date_debut'] ? details['date_debut'].slice(0,-9) : null;
        // details['date_fin']= details['date_fin'] ? details['date_fin'].slice(0,-9) : null;
      });
      state.packs = packs;
    }catch (e) {
    }

    //state.pagination = params.payload.pagination;
    //state.filters = params.filters || state.filters;
  },
  PACKS_ERROR(state) {
    state.packs = [];
    state.hasError = true;
  },
  PACKS_LOADED(state) {
    //state.isLoading = false;
  },
  PACK_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  PACK_PROCESSING_END(state) {
    //state.isLoading = false;
  },
  PACK_ERROR(state) {
    //state.isLoading = false;
  },
  UPDATE_A_PACK(state, enviemoment) {
    let index = state.packs.findIndex((elem) => elem.article_id === enviemoment.article_id);
    state.packs = state.packs.filter(element => element.article_id !== enviemoment.article_id);
    // enviemoment['date_debut']=enviemoment['date_debut'].slice(0,-9);
    // enviemoment['date_fin']=enviemoment['date_fin'].slice(0,-9);
    state.packs.splice(index, 0, enviemoment);
  },
  GET_PACK_SUCCES(state, details) {
    // details['date_debut']=details['date_debut'].slice(0,-9);
    // details['date_fin']=details['date_fin'].slice(0,-9);
    state.details = details
    //state.isLoading = false;
  },
  ADD_PACK_TO_LIST(state, pack) {
    state.packs.unshift(pack);
  },
  REMOVE_PACK_TO_LIST(state, pack) {
    state.packs = state.packs.filter(element => element.article_id !== pack.article_id);
  },
  REMOVE_PACK_IMAGE(state,article_id){
    let index = state.packs.findIndex((elem) => elem.article_id === article_id);
    state.packs[index].image=null
  }
};
export const actions = {
  async getPacks({commit}) {
    commit('PACKS_LOAD');
    this.$api.request(packRoutes.list)
      .then(response => {
        commit('PACKS_SUCCES', response.payload);
      })
      .catch(error => {
        commit('PACKS_ERROR');
      })
      .finally(() => commit('PACKS_LOADED'));
  },
  async createPack({commit}, params) {
    commit('PACK_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(packRoutes.create,{}, params.formData)
      .then(response => {
        commit('CLOSE_MODAL',true);
        //commit('PACK_SUCCES', response);
        commit('ADD_PACK_TO_LIST', response.payload);
        const data = params.nextRequest.firstRequest;
        if(data && data.length>0)
        this.dispatch('enviemoment/attachItems',{items:data,id:response.payload.article_id})
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('PACK_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('PACK_PROCESSING_END')
      });
  },
  async updatePack({commit}, params) {
    commit('PACK_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(packRoutes.update, {id: params.id}, params.formData)
      .then(response => {
        //commit('PACK_SUCCES', response);
        commit('UPDATE_A_PACK', response.payload);
        commit('CLOSE_MODAL',true);
        if(params.nextRequest.secondRequest){
          this.dispatch('enviemoment/detachItems',{items:params.nextRequest,id:params.id});
        }else{
          const data = params.nextRequest.firstRequest;
          if(data && data.length>0)
          this.dispatch('enviemoment/attachItems',{items:data,id:params.id});
        }
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('PACK_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('PACK_PROCESSING_END')
      });
  },
  async attachItems({commit}, params) {
    commit('PACK_PROCESSING_START');
    await this.$api.request(packRoutes.attach, {id: params.id}, params.items)
      .then(response => {
        //commit('PACK_SUCCES', response);
        commit('UPDATE_A_PACK', response.payload);
      })
      .catch(error => {
        commit('PACK_ERROR');
      })
      .finally(() => commit('PACK_PROCESSING_END'));
  },
  async detachItems({commit}, params) {
    commit('PACK_PROCESSING_START');
    await this.$api.request(packRoutes.detach, {id: params.id}, params.items.secondRequest)
      .then(response => {
        //commit('', response);
        this.dispatch('enviemoment/attachItems',{items:params.items.firstRequest,id:params.id});
      })
      .catch(error => {
        commit('PACK_ERROR');
      })
      .finally(() => commit('PACK_PROCESSING_END'));
  },
  async deletePack({commit}, params) {
    commit('PACK_PROCESSING_START');
    await this.$api.request(packRoutes.delete, {id: params.article_id})
      .then(response => {
        //commit('PACK_SUCCES', response);
        commit('REMOVE_PACK_TO_LIST', params);
      })
      .catch(error => {
        commit('PACK_ERROR');
      })
      .finally(() => commit('PACK_PROCESSING_END'));
  },
  async getPack({commit}, params) {
    commit('PACK_PROCESSING_START');
    await this.$api.request(packRoutes.get, {id: params.article_id})
      .then(response => {
        commit('GET_PACK_SUCCES', response.payload);
      })
      .catch(error => {
        commit('PACK_ERROR');
      })
      .finally(() => commit('PACK_PROCESSING_END'));
  },
  async removeImage({ commit }, params){
    commit('REMOVE_PACK_IMAGE', params.id);
  }
};
